import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class DocumentNode {

    private _documentId: string;
    private _treeNodeId: number;
    private _name: string;
    private _sortNumber: number;
    private _revisionNo: string;
    private _fileName: string;
    private _documentStored: boolean;

    public constructor(documentId: string, treeNodeId: number, name: string, sortNumber: number, revisionNo: string, fileName: string, documentStored: boolean) {

        this._documentId = documentId;
        this._treeNodeId = treeNodeId;
        this._name = name;
        this._sortNumber = sortNumber;
        this._revisionNo = revisionNo;
        this._fileName = fileName;
        this._documentStored = documentStored;
    }

    public get documentId(): string {
        return this._documentId;
    }

    public set documentId(value: string) {
        this._documentId = value;
    }

    public get treeNodeId(): number {
        return this._treeNodeId;
    }

    public set treeNodeId(value: number) {
        this._treeNodeId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get sortNumber(): number {
        return this._sortNumber;
    }

    public set sortNumber(value: number) {
        this._sortNumber = value;
    }

    public get revisionNo(): string {
        return this._revisionNo;
    }

    public set revisionNo(value: string) {
        this._revisionNo = value;
    }

    public get fileName(): string {
        return this._fileName;
    }

    public set fileName(value: string) {
        this._fileName = value;
    }

    public get documentStored(): boolean {
        return this._documentStored;
    }

    public set documentStored(value: boolean) {
        this._documentStored = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): DocumentNode | null {

        const documentId: string | null = safeParseNullDefault<string>(json?.documentId, '');
        const treeNodeId: number | null = safeParseNullDefault<number>(json?.treeNodeId, 0);
        const name: string = safeParse<string>(json?.name, '');
        const sortNumber: number | null = safeParseNullDefault<number>(json?.sortNumber, 0);
        const revisionNo: string = safeParse<string>(json?.revisionNo, '');
        const fileName: string | null = safeParseNullDefault<string>(json?.fileName, '');
        
        if (documentId === null || treeNodeId === null || sortNumber === null || fileName === null || documentId === '' || fileName === '') {
            return null;
        }

        return new DocumentNode(documentId, treeNodeId, name, sortNumber, revisionNo, fileName, false);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): DocumentNode | null {

        const documentId: string | null = safeParseNullDefault<string>(object?._documentId, '');
        const treeNodeId: number | null = safeParseNullDefault<number>(object?._treeNodeId, 0);
        const name: string = safeParse<string>(object?._name, '');
        const sortNumber: number | null = safeParseNullDefault<number>(object?._sortNumber, 0);
        const revisionNo: string = safeParse<string>(object?._revisionNo, '');
        const fileName: string | null = safeParseNullDefault<string>(object?._fileName, '');
        const documentStored: boolean = safeParse<boolean>(object?._documentStored, false);
        
        if (documentId === null || treeNodeId === null || sortNumber === null || fileName === null || documentId === '' || fileName === '') {
            return null;
        }

        return new DocumentNode(documentId, treeNodeId, name, sortNumber, revisionNo, fileName, documentStored);
    }
}

export default DocumentNode;